
import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StateMasterService {

  AppUrl = '';
  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
      this.AppUrl = sessionStorage.getItem('BaseURL') || '';
    }
  }

  getState(TokenKey: string, productId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/StateMaster/GetStateMaster/' + productId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetStateMasterFindByClientId(TokenKey: string, ClientID: any, productId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/StateMaster/GetStateMasterFindByClientId/' + ClientID + '/' + productId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetStateMasterFindByCompanyId(TokenKey: string, companyId: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/StateMaster/GetStateMasterFindByCompanyId/' + companyId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetStateMasterFindByPaged(TokenKey: string, PageNumber: any, PageSize: any, WhereCondition: any, OrderBy: any, StateName: any, productId: number,IsExport:boolean): Observable<any> {
    this.setAPIUrl();
    const data = 'api/StateMaster/GetStateMasterFindByPaged/' + PageNumber + '/' + PageSize + '/' + WhereCondition + '/' + OrderBy + '/' + StateName + '/' + productId+'/'+IsExport;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  i360ManageSubscriptionClientId(TokenKey: string, ClientID: any, productId: number, IsAdmin: boolean): Observable<any> {
    this.setAPIUrl();
    const data = 'api/Jsi360/i360ManageSubscriptionClientId/' + ClientID + '/' + productId + '/' + IsAdmin;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }

  GetAllStateMaster(TokenKey: string, PageNumber: number, PageSize: number, filterText: string, orderBy: string, productId: number,IsExport:boolean): Observable<any> {
    this.setAPIUrl();
    const data = 'api/StateMaster/GetAllState/' + filterText + '/' + PageNumber + '/' + PageSize + '/' + orderBy + '/' + productId+'/'+IsExport;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  AddUpdateNewStateMaster(TokenKey: string, addNewActionModel: any): Observable<any> {
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/StateMaster/CreateOrUpdateState';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, addNewActionModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetStateMasterById(TokenKey: string, stateId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/StateMaster/GetStateById/' + stateId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  DeleteState(TokenKey: string, stateId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/StateMaster/DeleteState/' + stateId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetStateMaster(TokenKey: string, module: string): Observable<any> {
    this.setAPIUrl();
    const data = 'api/StateMaster/GetState/' + module;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  UpdateStateWithModule(TokenKey: string, addNewActionModel: any): Observable<any> {
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/StateMaster/UpdateStateWithModule';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, addNewActionModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getStateV2(TokenKey: string, productId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/StateMaster/V2/GetStateMaster/' + productId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getBriefingsStateMaster(TokenKey: string, productId: number,userId:number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/StateMaster/GetBriefingsStateMaster/' + productId+'/'+userId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  stateStatusUpdate(TokenKey: string, stateStatusModel: any): Observable<any> {
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/StateMaster/stateStatusUpdate';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, stateStatusModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetStateMasterFindByPagedV2(TokenKey: string, PageNumber: any, PageSize: any, WhereCondition: any, OrderBy: any, StateName: any, productId: number,Status:number,IsExport:boolean): Observable<any> {
    this.setAPIUrl();
    const data = 'api/StateMaster/GetStateMasterFindByPaged_V2/' + PageNumber + '/' + PageSize + '/' + WhereCondition + '/' + OrderBy + '/' + StateName + '/' + productId+'/'+Status+'/'+IsExport;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  Getcrrasubscriptionstate(TokenKey: string, ClientID: any, IsAdmin: boolean): Observable<any> {
    this.setAPIUrl();
    const data = 'api/CRRAContentMaster/crrasubscriptionstate/' + ClientID + '/' + IsAdmin;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }
}
